<template>
  <workshop-management
    :get-statuses="apis.workshop.getWorkshopStatuses"
    :get-all="apis.workshop.getAllWorkshop"
    :get-details="apis.workshop.getWorkshopDetail"
    :add-participant="apis.workshop.addWorkshopParticipant"
    :last-registered-participant="apis.workshop.getLatestParticipant"
    :update-participant-status="apis.workshop.updateParticipantWorkshopStatus"
    :validate-tests="apis.workshop.validateWorkshopTests"
    :retake-exam="apis.workshop.retakeWorkshopExam"
    :redeem="apis.workshop.redeemWorkshop"
    :download-certificate="apis.report.downloadWorkshopCertificate"
    :download-file="apis.general.downloadDocumentByAttachmentId"
  />
</template>
<script>
import WorkshopManagement from 'workshop-management';

import * as workshopService from '@/services/operations/dashboard-management';
import reportService from '@/services/report';
import generalService from '@/services/pei/general';

export default {
  name: 'OperationsWorkshops',
  components: { WorkshopManagement },
  computed: {
    apis() {
      return Object.freeze({
        workshop: workshopService,
        general: generalService,
        report: reportService,
      });
    },
  },
};
</script>
